<template>

    <div class="footer-component" v-if="router && !route.meta.hideFooter">
        <div class="container-fluid">
            <div class="row no-gutters">
                <div class="col-auto">
                    <footer-steps :selectedQuote="selectedQuote" :yourProfileCompleted="yourProfileStageCompleted" :adminPortalData="adminPortalData" />
                </div>
                <div class="col">

                    <ul class="right">
                        <li>
                            <VTooltip :disabled="!tooltip" :triggers="['click']">
                                <button class="contact-us text-uppercase">
                                    <i class="icon-call"></i>
                                    <span>Contact Us</span>
                                </button>
                                <template #popper>
                                    <div class="contact-inner">
                                        <div class="row">
                                            <div class="col-auto">
                                                <h4>Contact Details</h4>
                                                <ul>
                                                    <li><a :href="'mailto:' + contactDetailsEmailAddress" class="email">{{ contactDetailsEmailAddress }}</a></li>
                                                    <li><a :href="'tel:' + contactDetailsTelephoneNumber" class="tel">{{ contactDetailsTelephoneNumber }}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </VTooltip>
                        </li>

                        <!-- Agree To Proceed (EULA) -->
                        <li v-if="$route.name === 'Agree to Proceed'">
                            <router-link :class="{'next text-uppercase': true, 'disabled': !eulaAccepted }" :to="{name: $route.meta.nextPage.name}" class="next text-uppercase">
                                {{$route.meta.nextPage.title}} <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <!-- Your Profile -->
                        <li v-if="route.name === 'Your Profile'">
                            <router-link :to="{name: 'Shortlist', params: { scheme: currentScheme }}" :class="{'next text-uppercase': true, disabled: !yourProfileStageCompleted}">
                                All my details are correct
                                <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <!-- Shortlist -->
                        <li v-if="$route.name === 'Shortlist'">
                            <router-link :to="shortlistNextLinkUrl" class="next text-uppercase">
                                {{ shortlistNextLinkTitle }}
                                <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <li v-if="$route.name === 'Car Comparison'">
                            <router-link v-if="selectedQuote.scheme === 'ecoamaps'" :event="selectedQuote ? 'click' : ''" :to="{ name: 'ECO / AMAPS Personal Details', params: { quoteId: (selectedQuote ? selectedQuote.quoteID : '') } }"  :class="{'next text-uppercase': true, disabled: !selectedQuote}">
                                {{$route.meta.nextPage.title}}
                                <i class="icon-arrow-right"></i>
                            </router-link>
                            <router-link v-else-if="selectedQuote.scheme === 'salsac'" :event="selectedQuote ? 'click' : ''" :to="{ name: 'Salary Sacrifice Personal Details', params: { quoteId: (selectedQuote ? selectedQuote.quoteID : '') } }"  :class="{'next text-uppercase': true, disabled: !selectedQuote}">
                                {{$route.meta.nextPage.title}}
                                <i class="icon-arrow-right"></i>
                            </router-link>

                            <router-link v-else-if="selectedQuote.scheme === 'bch' && !hasInlineConfiguration" :event="selectedQuote ? 'click' : ''" :to="{ name: 'Business Contract Hire Personal Details', params: { quoteId: (selectedQuote ? selectedQuote.quoteID : '') } }" :class="{'next text-uppercase': true, disabled: !selectedQuote}">
                                {{$route.meta.nextPage.title}}
                                <i class="icon-arrow-right"></i>
                            </router-link>
                            <a href="" v-else-if="selectedQuote.scheme === 'bch' && hasInlineConfiguration" @click.prevent="saveConfigurationInline()" :class="{'next text-uppercase': true, 'disabled': !selectedQuote }">{{$route.meta.nextPage.title}}</a>

                            <a v-else href="#" disabled="true" class="next text-uppercase">{{$route.meta.nextPage.title}} <i class="icon-arrow-right"></i></a>
                        </li>

                        <!-- Configure Vehicle -->
                        <li v-if="$route.name === 'Configure Vehicle'">
                            <template v-if="!isCurrentConfiguredQuoteValid">
                                <a href="" @click.prevent="" :class="{'next text-uppercase': true, 'disabled': !isCurrentConfiguredQuoteValid }">Select a colour &amp; trim before saving</a>
                            </template>
                            <template v-else>
                                <a href="" @click.prevent="saveConfiguration()" class="next text-uppercase">Save Configuration</a>
                            </template>
                        </li>

                        <li v-if="$route.name === 'Salary Sacrifice Personal Details'">
                            <router-link :to="{name: $route.meta.nextPage.name}" :class="{'next text-uppercase': true, disabled: !stepOneAgreed}">
                                <template v-if="nextPageTitle">{{ nextPageTitle }}</template>
                                <template v-else>{{$route.meta.nextPage.title}}</template>
                                <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <li v-if="$route.name === 'Salary Sacrifice Product Details'">
                            <router-link :to="{name: $route.meta.nextPage.name}" :class="{'next text-uppercase': true, disabled: !stepTwoAgreed}">
                                <template v-if="nextPageTitle">{{ nextPageTitle }}</template>
                                <template v-else>{{$route.meta.nextPage.title}}</template>
                                <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <li v-if="$route.name === 'Salary Sacrifice Order Details'">
                            <a href="" v-if="!stepThreeAgreed" @click.prevent="" class="next text-uppercase disabled">Submit Order</a>
                            <a href="" v-else @click.prevent="submitOrder()" class="next text-uppercase">Submit Order</a>
                        </li>

                        <li v-if="$route.name === 'ECO / AMAPS Personal Details'">
                            <router-link :to="{name: $route.meta.nextPage.name}" :class="{'next text-uppercase': true, disabled: !stepOneAgreed}">
                                <template v-if="nextPageTitle">{{ nextPageTitle }}</template>
                                <template v-else>{{$route.meta.nextPage.title}}</template>
                                <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <li v-if="$route.name === 'ECO / AMAPS Product Details'">
                            <router-link :to="{name: $route.meta.nextPage.name}" :class="{'next text-uppercase': true, disabled: !stepTwoAgreed}">
                                <template v-if="nextPageTitle">{{ nextPageTitle }}</template>
                                <template v-else>{{$route.meta.nextPage.title}}</template>
                                <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <li v-if="$route.name === 'ECO / AMAPS Order Details'">
                            <a href="" v-if="!stepThreeAgreed" @click.prevent="" class="next text-uppercase disabled">Submit Order</a>
                            <a href="" v-else @click.prevent="submitOrder()" class="next text-uppercase">Submit Order</a>
                        </li>

                        <li v-if="$route.name === 'Business Contract Hire Personal Details'">
                            <router-link :to="{name: $route.meta.nextPage.name}" :class="{'next text-uppercase': true, disabled: !stepOneAgreed}">
                                <template v-if="nextPageTitle">{{ nextPageTitle }}</template>
                                <template v-else>{{$route.meta.nextPage.title}}</template>
                                <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <li v-if="$route.name === 'Business Contract Hire Product Details'">
                            <router-link :to="{name: $route.meta.nextPage.name}" :class="{'next text-uppercase': true, disabled: canPassStageTwo}">
                                <template v-if="nextPageTitle">{{ nextPageTitle }}</template>
                                <template v-else>{{$route.meta.nextPage.title}}</template>
                                <i class="icon-arrow-right"></i>
                            </router-link>
                        </li>

                        <li v-if="$route.name === 'Business Contract Hire Order Details'">
                            <a href="" v-if="!stepThreeAgreed" @click.prevent="" class="next text-uppercase disabled">Submit Order</a>
                            <a href="" v-else @click.prevent="submitOrder()" class="next text-uppercase">Submit Order</a>
                        </li>

                        <li v-if="(
                            $route.name !== 'Car Comparison' &&
                            $route.name !== 'Agree to Proceed' &&
                            $route.name !== 'Your Profile' &&
                            $route.name !== 'Shortlist' &&
                            $route.name !== 'Configure Vehicle' &&
                            // $route.name !== 'Salary Sacrifice Order Process' &&
                            $route.name !== 'Salary Sacrifice Personal Details' &&
                            $route.name !== 'Salary Sacrifice Product Details' &&
                            $route.name !== 'Salary Sacrifice Document Acceptance' &&
                            $route.name !== 'Salary Sacrifice Order Details' &&
                            $route.name !== 'ECO / AMAPS Personal Details' &&
                            $route.name !== 'ECO / AMAPS Product Details' &&
                            $route.name !== 'ECO / AMAPS Document Acceptance' &&
                            $route.name !== 'ECO / AMAPS Order Details' &&
                            $route.name !== 'Business Contract Hire Personal Details' &&
                            $route.name !== 'Business Contract Hire Product Details' &&
                            $route.name !== 'Business Contract Hire Order Details'
                        )">
                            <template v-if="$route.meta && $route.meta.nextPage">
                                <router-link :to="{name: $route.meta.nextPage.name}" class="next text-uppercase">
                                    <template v-if="nextPageTitle">{{ nextPageTitle }}</template>
                                    <template v-else>{{$route.meta.nextPage.title}}</template>
                                    <i class="icon-arrow-right"></i>
                                </router-link>
                            </template>
                        </li>

                    </ul>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import FooterSteps from "./footer-steps";
    import { useRoute, useRouter } from 'vue-router';
    import {computed} from "vue";

    export default {
        emits: [],
        components: {FooterSteps},

        props: {
            eulaAccepted: Boolean,
            policiesAccepted: Boolean,
            yourProfileCompleted: Boolean,
            selectedQuote: Object,
            canSubmitOrder: Boolean,
            stepOneAgreed: Boolean,
            stepTwoAgreed: Boolean,
            tradeUpTradeDownAgreed: Boolean,
            stepThreeAgreed: Boolean,
            nextPageTitle: String,
            adminPortalData: Object,
            adminPortalPrimaryProduct: Object,
            currentConfiguredQuote: Object,
        },

        setup () {
            const route = useRoute();
            const router = useRouter();
            const routeName = computed(() => useRoute().name);
            return { route, router, routeName }
        },

        data() {
            return {
                tooltip: true,
            }
        },

        methods: {
            saveConfiguration() {
              this.$emit('saveConfiguration', {status: true});
            },
            saveConfigurationInline() {
              this.$emit('saveConfigurationInline', {status: true});
            },

            submitOrder() {
                this.$emit('submitOrder');
            }
        },

        computed:{
          currentScheme () {
            return (this.route.params?.scheme ?? '0');
          },
          hasTradeUpTradeDownDesc() {
            return this?.adminPortalData?.content?.products?.bch[0]?.order_stage_two_trade_up_trade_down_description.length > 0;
          },
          canPassStageTwo() {
            if(this.hasTradeUpTradeDownDesc) {
              return !this.stepTwoAgreed || !this.tradeUpTradeDownAgreed
            }

            return !this.stepTwoAgreed;
          },
          hasInlineConfiguration() {
            return this?.adminPortalData?.content?.products?.bch ? this?.adminPortalData?.content?.products?.bch[0]?.configure_show_minimal_options : false;
          },

            yourProfileStageCompleted() {
                if (this.adminPortalData?.content?.products?.ecoamaps) {
                    return true;
                }

                return this.yourProfileCompleted;
            },

            isCurrentConfiguredQuoteValid() {
                return !(!this.currentConfiguredQuote.color || !this.currentConfiguredQuote.color.value ||
                    !this.currentConfiguredQuote.trim || !this.currentConfiguredQuote.trim.value);
            },

            shortlistNextLinkUrl() {
                let linkUrl = '';

                if (this.adminPortalData.content) {
                    linkUrl = this.adminPortalData?.content?.products?.salsac && this.adminPortalData?.content?.products?.ecoamaps
                        ? '/ecoamaps/shortlist/2/' + this.kebab(this.adminPortalData.content.products.ecoamaps[0].name)
                        : `/${this.currentScheme}/car-comparison`;
                }

                return linkUrl;
            },

            shortlistNextLinkTitle() {
                let linkTitle = '';

                if (this.adminPortalData.content) {
                    linkTitle = this.adminPortalData?.content?.products?.salsac && this.adminPortalData?.content?.products?.ecoamaps
                        ? 'I’m happy with my shortlist'
                        : 'Compare my shortlists';
                }

                return linkTitle;
            },

            contactDetailsEmailAddress() {
                return this.adminPortalData.content?.customer?.vls_account_manager_email_address ? this.adminPortalData.content.customer.vls_account_manager_email_address : '';
            },

            contactDetailsTelephoneNumber() {
                return this.adminPortalData.content?.customer?.vls_account_manager_telephone_number ? this.adminPortalData.content.customer.vls_account_manager_telephone_number : '';
            }

        }
    }
</script>
